import { render, staticRenderFns } from "./1-2.AddPayment.vue?vue&type=template&id=520f1c75&scoped=true"
import script from "./1-2.AddPayment.vue?vue&type=script&lang=js"
export * from "./1-2.AddPayment.vue?vue&type=script&lang=js"
import style0 from "./1-2.AddPayment.vue?vue&type=style&index=0&id=520f1c75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520f1c75",
  null
  
)

export default component.exports